import type { AppProblemModel } from '@/services/api/AppProblemModel'
import { presentationFor } from './presentationFor'

export const problemTitle = (problem: AppProblemModel): string =>
  presentationFor(problem.code).title
